import { render, staticRenderFns } from "./CorporateCategory.vue?vue&type=template&id=ac99cd04&scoped=true"
import script from "./CorporateCategory.vue?vue&type=script&lang=js"
export * from "./CorporateCategory.vue?vue&type=script&lang=js"
import style0 from "./CorporateCategory.vue?vue&type=style&index=0&id=ac99cd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac99cd04",
  null
  
)

export default component.exports